import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight'
})

export class HighlightSearchPipe implements PipeTransform {

    transform(value: string, args: any): any {
      if (value && args && (typeof args === 'string' || args instanceof String)) {
        let stringValue = value?.toString() ?? '';
        let index = stringValue?.toLowerCase().indexOf(args?.toLowerCase());
        if (index >= 0) { 
          value = stringValue.substring(0,index) + "<span class='highlight'>" + stringValue.substring(index,index+args.length) + "</span>" + stringValue.substring(index + args.length);
        }
      }
      return value;
    }
}